import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api";
import Layout from "../../components/Layout";
import { useAuth } from "../../AuthContext";
import { Buildings, ChartBar, Gear, CaretRight, UserCircle, Warning, Gauge, UserPlus, FileText, ClockCounterClockwise, Users } from "@phosphor-icons/react";

const LINKS = [
  { to: "/properties", label: "Properties & Agreements", desc: "Addresses, access notes, recurring services", icon: Buildings },
  { to: "/owners", label: "Owners", desc: "Accounts, invites, password resets, transfers", icon: UserCircle },
  { to: "/history", label: "Job History", desc: "Every completed visit, searchable by property or crew", icon: ClockCounterClockwise },
  { to: "/issues", label: "Issues", desc: "Crew observations, triage, owner notifications", icon: Warning, badge: "issues" },
  { to: "/leads", label: "Leads & Commissions", desc: "Who's bringing in new business", icon: UserPlus },
  { to: "/more/crew", label: "Crew", desc: "Roster and payables in one place", icon: Users },
];

const BELOW_DIVIDER = [
  { to: "/metrics", label: "Numbers", desc: "Response times, revenue, output", icon: ChartBar },
  { to: "/settings", label: "Settings", desc: "Business profile, services, billing, team", icon: Gear, operatorOnly: true },
];

const PLATFORM_ONLY = { to: "/platform", label: "Platform metrics", desc: "Veloktify-internal aggregate counts", icon: Gauge, platformOnly: true };

export default function More() {
  const { user } = useAuth();
  const [attn, setAttn] = useState({});
  useEffect(() => { api.get("/attention").then((r) => setAttn(r.data || {})).catch(() => {}); }, []);
  const show = (l) => (!l.operatorOnly || user?.role === "operator") && (!l.platformOnly || user?.platform_admin);
  const rows = [...LINKS.filter(show), ...(user?.platform_admin ? [PLATFORM_ONLY] : [])];

  const Row = ({ l }) => (
    <Link key={l.to} to={l.to} data-testid={`more-${l.to.slice(1).replace(/\//g, "-").split("?")[0]}`}>
      <div className="card-flat relative flex items-center gap-4 p-5 transition-colors hover:bg-muted/50">
        <l.icon size={28} weight="bold" className="text-primary" />
        <div className="flex-1">
          <p className="font-semibold">{l.label}</p>
          <p className="text-sm text-muted-foreground">{l.desc}</p>
        </div>
        {l.badge && (attn[l.badge] || 0) > 0 && (
          <span data-testid={`badge-more-${l.badge}`} className="font-heading text-xl font-bold leading-none text-destructive">*</span>
        )}
        <CaretRight size={20} weight="bold" className="text-muted-foreground" />
      </div>
    </Link>
  );

  return (
    <Layout title="More">
      <div className="space-y-2" data-testid="more-links">
        {rows.map((l) => <Row key={l.to} l={l} />)}
      </div>
      <div className="my-5 border-t border-border" data-testid="more-divider" />
      <div className="space-y-2" data-testid="more-links-bottom">
        {BELOW_DIVIDER.filter(show).map((l) => <Row key={l.to} l={l} />)}
      </div>
    </Layout>
  );
}
